export class CodingCode {
    element: string;
    value: string;
}